// *************************************
// Submit order page
// **************************************

function printOrderItem(id) {
  let item = undefined;

  let burlapQuantity = orderItems[id].orderItem.burlapQuantity;
  let burlapType = orderItems[id].orderItem.burlapType == 'Unselected' ? 'Type not selected' : orderItems[id].orderItem.burlapType;
  let burlapTreatment = orderItems[id].orderItem.burlapTreatment == 'Unselected' ? 'Treatment not selected' : orderItems[id].orderItem.burlapTreatment;
  let burlapGrade = orderItems[id].orderItem.burlapGrade == 'Unselected' ? 'Grade not selected' : orderItems[id].orderItem.burlapGrade;

  item = `<li class="order-item text-md mb-1 p-1 lg:mb-2 lg:p-2 max-w-40 mx-auto bg-grey-200 text-left relative">`;

  if (orderItems[id].orderItem.productCategory == 'basket') {
    let palletsTerm = 'pallet';

    if (orderItems[id].orderItem.quantity > 1) {
      palletsTerm = 'pallets';
    }

    let taper = orderItems[id].orderItem.basketCategory.match(/°/) ? '' : ` ${orderItems[id].orderItem.taper}`;

    if (taper == ' Other') {
      taper = '';
    }

    let basketCategory = orderItems[id].orderItem.basketCategory;
    let basketCategorySlug = orderItems[id].orderItem.basketCategorySlug;
    let basketGrade = orderItems[id].orderItem.grade == 'Unselected' ? 'Grade not selected' : `• ${orderItems[id].orderItem.grade}`;
    let basketUnits = orderItems[id].orderItem.basketUnits;
    let bottomType = orderItems[id].orderItem.bottomType == 'Unselected' ? 'Bottom Type not selected' : `• ${orderItems[id].orderItem.bottomType} bottom`;
    let quantity = orderItems[id].orderItem.quantity;
    let topSize = orderItems[id].orderItem.topSize;

    item += `
        <div class="w-full text-h3 mb-.5">
            <div class="no-underline leading-none">
                ${topSize}" ${basketCategory}${taper} Wire Basket
            </div>
        </div>
        <div class="uppercase">
            <span>${basketGrade}</span>
            <span class="inline-block ml-.5">${bottomType}</span>
        </div>
        <div class="py-.75 lg:py-1">
            <span class="text-md font-bold px-.5 py-.25 uppercase bg-grey-200">
                ${quantity} ${palletsTerm}
                <span class="text-sm">
                    (${basketUnits} units)
                </span>
            </span>
        </div>

        <div class="border-t-2 border-b-2 border-grey-300 py-.5">
            <strong class="inline-block mr-.5">Burlap:</strong>
            <span class="inline-block mr-.5 white-space-no-wrap">${burlapQuantity} Bales</span>
            <span class="inline-block mr-.5 white-space-no-wrap">${burlapType}</span>
            <span class="inline-block mr-.5 white-space-no-wrap">${burlapTreatment}</span>
            <span class="inline-block mr-.5 white-space-no-wrap">${burlapGrade}</span>
        </div>
        `;
  } else if (orderItems[id].orderItem.productCategory == 'butlap' || orderItems[id].orderItem.productCategory == 'burlap') {
    item += `
        <div class="w-full text-h3 mb-.5">
            Burlap
        </div>
        <div>
            <span class="inline-block mr-.5 white-space-no-wrap">${burlapQuantity} Bales</span>
            <span class="inline-block mr-.5 white-space-no-wrap">${burlapType}</span>
            <span class="inline-block mr-.5 white-space-no-wrap">${burlapTreatment}</span>
            <span class="inline-block mr-.5 white-space-no-wrap">${burlapGrade}</span>
        </div>`;
  }

  item += `
        <div class="absolute pin-t pin-r pr-.5 lg:pt-.5 lg:pr-1">
            <a data-id="${orderItems[id].orderItem.id}" class="order-remove-item leading-none text-sm no-underline hover:underline uppercase" href="#">Remove</a>
        </div>
    </li>`;

  if ($('.order-list').length > 0) {
    $('.order-list').append(item);
  }

  updateCartCount();
}

// Populate our hidden products being ordered field
function setOrderBasketFieldData() {
  const orderItems = JSON.parse(localStorage.getItem('orderItems'));

  if ($('#input-baskets_requested').length > 0) {
    let orderItemsString = '';

    for (var i = 0; i < orderItems.length; i++) {
      if (orderItems[i].orderItem.id) {
        if (orderItems[i].orderItem.productCategory == 'basket') {
          orderItemsString += `
                    Product: ${orderItems[i].orderItem.productCategory}
                    Basket: ${orderItems[i].orderItem.basketCategory}
                    Taper: ${orderItems[i].orderItem.taper}
                    Top Size: ${orderItems[i].orderItem.topSize}
                    Grade: ${orderItems[i].orderItem.grade}
                    Bottom type: ${orderItems[i].orderItem.bottomType}
                    Basket Quantity: ${orderItems[i].orderItem.quantity} Pallets (${orderItems[i].orderItem.basketUnits} units)
                    Burlap Type: ${orderItems[i].orderItem.burlapType}
                    Burlap Quantity: ${orderItems[i].orderItem.burlapQuantity}
                    Burlap Treatment: ${orderItems[i].orderItem.burlapTreatment}
                    Burlap Grade: ${orderItems[i].orderItem.burlapGrade}
            `;
        } else if (orderItems[i].orderItem.productCategory == 'burlap') {
          orderItemsString += `
                        Product: ${orderItems[i].orderItem.productCategory}
                        Burlap Type: ${orderItems[i].orderItem.burlapType}
                        Burlap Quantity: ${orderItems[i].orderItem.burlapQuantity}
                        Burlap Treatment: ${orderItems[i].orderItem.burlapTreatment}
                        Burlap Grade: ${orderItems[i].orderItem.burlapGrade}
                        `;
        } else {
          // do nothing
        }
      }
    }

    $('#input-baskets_requested').val(orderItemsString);
  }
}

// On page load, list the orders that are in local storage
if ($('.order-list').length > 0) {
  if (orderItems.length > 0) {
    for (let i = 0; i < orderItems.length; i++) {
      printOrderItem(i);
    }
  } else {
    $('.order-list').html(`<p class="text-center">Your order is empty. Time to <a href="/wire-baskets">start shopping.</a></p>`);
  }

  setOrderBasketFieldData();
}

// Remove items from the order list
$('.order-remove-item').on('click', function() {
  const removeId = $(this).data('id');

  localStorage.removeItem(`orderItems[${removeId}]`);
  $(this)
    .closest('li.order-item')
    .remove();

  let orderItems = JSON.parse(localStorage.getItem('orderItems'));

  orderItems = orderItems.filter(function(obj) {
    return obj.orderItem.id !== removeId;
  });

  localStorage.setItem('orderItems', JSON.stringify(orderItems));

  if (orderItems.length < 1) {
    $('.order-list').html(`<p class="text-center">Your order is empty. Time to <a href="/wire-baskets">start shopping.</a></p>`);
  }

  setOrderBasketFieldData();
  updateCartCount();

  return false;
});
